import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import GetApp from "@material-ui/icons/GetApp";
import { Lightbox } from "react-modal-image";
import useAuthenticatedMedia from "../../hooks/useAuthenticatedMedia";
import { downloadMediaFile, mediaFileName } from "../../utils/downloadMedia";

const useStyles = makeStyles(() => ({
  previewWrapper: {
    position: "relative",
    display: "inline-block",
    maxWidth: 320,
  },
  messageMedia: {
    objectFit: "contain",
    width: 320,
    maxWidth: "100%",
    maxHeight: 320,
    height: "auto",
    borderRadius: 8,
    cursor: "pointer",
    display: "block",
  },
  downloadPreview: {
    position: "absolute",
    top: 6,
    right: 6,
    width: 34,
    height: 34,
    background: "rgba(255,255,255,.92)",
    zIndex: 2,
    "&:hover": {
      background: "#fff",
    },
  },
  lightboxDownload: {
    position: "fixed",
    top: 12,
    right: 92,
    zIndex: 2147483647,
    color: "#fff",
    background: "rgba(0,0,0,.55)",
    "&:hover": {
      background: "rgba(0,0,0,.8)",
    },
  },
}));

const ModalImageCors = ({ imageUrl }) => {
  const classes = useStyles();
  const displayUrl = useAuthenticatedMedia(imageUrl);
  const [open, setOpen] = useState(false);

  const handleDownload = async (event) => {
    if (event && typeof event.preventDefault === "function") event.preventDefault();
    if (event && typeof event.stopPropagation === "function") event.stopPropagation();
    try {
      await downloadMediaFile(imageUrl, mediaFileName(imageUrl));
    } catch (err) {
      console.error("Erro ao baixar imagem:", err);
    }
  };

  return (
    <>
      <div className={classes.previewWrapper}>
        <img
          src={displayUrl}
          alt="image"
          className={classes.messageMedia}
          onClick={() => { if (displayUrl) setOpen(true); }}
        />
        <IconButton
          size="small"
          className={classes.downloadPreview}
          onClick={handleDownload}
          title="Baixar imagem"
        >
          <GetApp fontSize="small" />
        </IconButton>
      </div>

      {open && (
        <>
          <Lightbox
            medium={displayUrl}
            large={displayUrl}
            alt="image"
            onClose={() => setOpen(false)}
            hideDownload={true}
            showRotate={true}
          />
          <IconButton
            className={classes.lightboxDownload}
            onClick={handleDownload}
            title="Baixar imagem"
          >
            <GetApp />
          </IconButton>
        </>
      )}
    </>
  );
};

export default ModalImageCors;
